import React from 'react'
import "./styles.scss"
import MenuOpen from "../../assets/menuOpen.svg"

function MenuButton() {
    function openMenu() {
        let menu = document.getElementById('MainMenu')
        if (menu && menu.style) menu.style.display = 'unset'
    }
// return <></>
return  <div className='openMenuContainer' onClick={openMenu}><div className='openMenu'><img className='openIcon' src={MenuOpen} alt='openIcon'/></div></div>
}

export default MenuButton;